<general></general>

<hr>

<ng-container *ngIf="!( isUsuarioExterno$ | async )">
	<section class="access-section">
		<main-email></main-email>
	</section>

	<hr>
</ng-container>

<section class="access-section">
	<main-app></main-app>
</section>

<hr>

<section class="access-section">
	<bases-conocimiento></bases-conocimiento>
</section>

<hr>

<section class="access-section">
	<report></report>
</section>